module.exports = __webpack_public_path__ + "static/media/signOutIcon.b6423470.svg";